import { Box, Text, OrderedList, ListItem, Image } from "@chakra-ui/react";
import background from "../assets/bg.jpg";
import Menubar from "../components/Menubar";
import { ACCENT_1_COLOR } from "../constants/color";
import { useTranslation } from "react-i18next";
import founderWithSokeImage from "../assets/soke-with-founder.jpg"
import { Helmet } from "react-helmet-async";

export default function Lineage() {
  const {t} = useTranslation();
  return (
    <Box
      display={"flex"}
      width={"100vw"}
      background={`transparent url(${background})`}
      bgRepeat={"repeat"}
      pb={"24px"}
    >
      <Helmet>
        <title>{t("lineageTitle")}</title>
        <meta name="description" content={t("lineageDesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/lineage" />
      </Helmet>
      <Box
        width={"100vw"}
        height={"auto"}
      >
        <Menubar />
        <Box
          width={"100vw"}
          px={{ base: "5vw", lg: "20vw" }}
          display={"flex"}
          flexDir={"column"}
          textAlign={"left"}
          mt={"18px"}
        >
          <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>
            {t("lineage")}
          </Text>
          <Text
            textColor={"#765946"}
            fontStyle={"italic"}
            fontSize={"18px"}
            mb={"24px"}
          >
            {t("lineageSubtitle")}
          </Text>

          <OrderedList mb={"24px"}>
            <ListItem>
              <Text as={"b"}>{t("founder")}:</Text> Tsuji Gettan Sukemochi, 1648-1727 Edo
            </ListItem>
            <ListItem>Tsuji Uheita, ~1742 Edo</ListItem>
            <ListItem>Tsuji Kimata Sukefusa, ~1761 Edo</ListItem>
            <ListItem>Tsuji Bunzaemon Sukekata, ~1787 Edo</ListItem>
            <ListItem mb={"18px"}>Tsuji Kimata Sukeyuki, ~1812 Edo</ListItem>
            <ListItem>Takahashi Hachisuke Mitsuaki, 1750~1809 Himeji</ListItem>
            <ListItem>Takahashi Tatsuzo Mitsuharu, 1784~1835 Himeji</ListItem>
            <ListItem>Takahashi Hachisuke Nariyuki, 1816~1880 Himeji</ListItem>
            <ListItem>Takahashi Tetsuo Takenari, 1830~1876 Himeji</ListItem>
            <ListItem>
              Takahashi Kyutaro Koun, 1859~1940 Dai Nippon Budokai
            </ListItem>
            <ListItem>
              Nakagawa Shiryu Shinichi, 1896~1981 Zen Nippon Iaido Renmei & Mugai-kai
            </ListItem>
            <ListItem>
              Nakatani Yoshitaro, 1930. Mugai-kai & Ryuo-kai
            </ListItem>
          </OrderedList>

          <Box display={"flex"} justifyContent={"center"} mb={"4px"}>
            <Image
              src={founderWithSokeImage}
              alt={"MURIN founder with Soke"}
              width={{base: "300px", md: "400px"}}
            />
          </Box>

          <Text mb={"18px"} align={"center"} fontSize={"14px"}>{t("lineagePictureDesc1")}</Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc1")}
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc2")}
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc3")}
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc4")}
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc5")}
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc7")}
          </Text>

          <Text textColor={ACCENT_1_COLOR} fontSize={"30px"} mb={"18px"}>
            Mugai Ryu Iaihyodo
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc8")}
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc9")}
          </Text>

          <Text mb={"18px"} textAlign={"justify"}>
            {t("lineageDesc10")}
          </Text>

          <Text mb={"24px"} textAlign={"justify"}>
            {t("lineageDesc11")}
          </Text>

          <Text mb={"24px"} textAlign={"justify"}>
            {t("lineageDesc12")}
          </Text>

          <Text mb={"24px"} textAlign={"justify"}>
            {t("lineageDesc13")}
          </Text>

          <Text mb={"24px"} textAlign={"justify"}>
            {t("lineageDesc14")}
          </Text>

          <Box display={"flex"} justifyContent={"center"} mb={"4px"}>
            <iframe title="pengangkatan soke" src="https://drive.google.com/file/d/1A7bTiG3Owsjjy3DKulGXSCC_Lv5LU17P/preview" width="100%" height="480" allow="autoplay" frameborder="0" allowFullScreen></iframe>
          </Box>
          <Text mb={"18px"} align={"center"} fontSize={"14px"}>{t("lineagePictureDesc2")}</Text>
        </Box>
      </Box>
    </Box>
  );
}
